<div class="container">
  <div class="actions">
    <button (click)="openCreate()" class="btn-action">
      <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
      Add Technology Partner
    </button>
  </div>
  <div class="container-table">
    <header class="top-header">
      <h3>Technology Partners</h3>
      <p>Manage webhook providers for technology partner onboarding.</p>
    </header>

    <!-- <div class="actions">
      <button class="btn-action" (click)="openCreate()">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Add Partner
      </button>
    </div> -->

    <div class="tab-head">
      <!-- <div class="search-panel">
      <label for="partnerSearch">Search</label>
      <div class="search-input-group">
        <input
          id="partnerSearch"
          type="text"
          placeholder="Search by display name or slug"
          [(ngModel)]="searchText"
          (keyup.enter)="onSearch()"
        />
        <button class="btn-action" type="button" (click)="onSearch()">
          <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
          Search
        </button>
        <button class="btn-action ghost-action" type="button" (click)="clearSearch()">
          Clear
        </button>
      </div>
    </div> -->
      <div class="search-bar">
        <input id="partnerSearch" type="text" placeholder="Search by display name or slug" [(ngModel)]="searchText"
          (keyup.enter)="onSearch()" class="search-input" />
      </div>
    </div>

    <div class="search-input-group table-filter-actions">
      <button class="btn-action" type="button" (click)="onSearch()">
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
        Apply Filters
      </button>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Display Name</th>
            <th>Name</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="6">Loading technology partners...</td>
          </tr>
          <tr *ngFor="let provider of providers; let i = index">
            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
            <td>{{ provider.display_name }}</td>
            <td>{{ provider.name }}</td>
            <td>
              <span class="status-pill" [class.active]="provider.is_active" [class.inactive]="!provider.is_active">
                {{ provider.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>{{ provider.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
            <td class="table-actions-cell">
              <div class="table-actions">
                <label class="toggle-switch" [title]="provider.is_active ? 'Disable' : 'Enable'">
                  <input type="checkbox" [checked]="provider.is_active" (change)="togglePartnerStatus(provider, $event)"
                    [disabled]="provider._toggling" />
                  <span class="toggle-slider"></span>
                </label>
                <button class="action-button bt-edit" type="button" (click)="openEdit(provider.id)" title="Edit">
                  <span>
                    <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                  </span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!loading && providers.length === 0">
            <td colspan="6">No technology partners found.</td>
          </tr>
        </tbody>
      </table>

      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
        <div class="pagination-controls">
          <label for="recordsPerPage">Records per page </label>
          <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
          </select>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
            <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
          </button>
          <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
            <fa-icon [icon]="['fas', 'angle-right']" class="fa-light"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
